import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  private _captchaToken: string;

  isShowCaptcha: boolean;
  IsShowCaptcha: Subject<boolean> = new Subject<boolean>();

  captchaExeSubscribe = new Subject<any>();
  captchaResetSubscribe = new Subject<any>();
  captchaResSubscribe = new Subject<{isSuccess: boolean, token: string}>();

  constructor() {
    this.isShowCaptcha = false;
    this.IsShowCaptcha.next(this.isShowCaptcha);
  }

  changeCaptchsState(value: boolean) {
    console.log('captcha service isShowCaptcha: ' + this.isShowCaptcha);
    console.log('captcha service changeCaptchsState: ' + value);
    if (this.isShowCaptcha !== value) {
      this.isShowCaptcha = value;
      this.IsShowCaptcha.next(this.isShowCaptcha);
    }
  }

  getCaptchaState() {
    return this.IsShowCaptcha.asObservable();
  }

  public get captchaToken() {
    return this._captchaToken;
  }
  public set captchaToken(value: string) {
    this._captchaToken = value;
  }

  // private _TokenReceived = new Subject<string>();
  // public _TokenExecute = new Subject<string>();
  // public get TokenReceived() {
  //   return this._TokenReceived;
  // }

  // constructor() { }


  load() {

  }
  reset() {
    this.captchaResetSubscribe.next();
  }
  setToken(newToken: string) {
    this.captchaToken = newToken;
  }
  getToken() {
    return this.captchaToken;
  }
  execute() {
    // this.reset();
    this.captchaExeSubscribe.next();
  }

  handleCaptchaRes(isSuccess: boolean, token: string) { 
    this.captchaResSubscribe.next({isSuccess: isSuccess, token: token});
    
  }
}

